const styles = {
  container: {
    templateColumns: "repeat(14, 1fr)",
    mt:12
  },

  content: {
    colStart: {
      "2xl": 6,
      xl: 5 ,
      md: 3,
      sm: 2,
      base: 1,
    },
    colEnd: {
      "2xl": 10,
      xl: 11,
      md: 13,
      sm: 14,
      base: 15,
    },
  },
};

export default styles;
